var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindBlk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80364 5.50894C1.84828 5.50894 1.89292 5.50894 1.89292 5.50894C2.0715 5.50894 2.25007 5.37501 2.29471 5.19644C2.78578 3.23215 4.52686 1.84822 6.5358 1.80357C8.32152 1.80357 9.92867 2.91965 10.5983 4.61608L9.79474 5.41966C9.75009 5.4643 9.79474 5.55359 9.83938 5.55359H11.9376C11.9822 5.55359 12.0269 5.50894 12.0269 5.4643V3.32144C12.0269 3.23215 11.9376 3.18751 11.893 3.27679L11.1787 4.03572C10.3751 2.16072 8.54473 1 6.5358 1C4.12507 1.04464 2.0715 2.69643 1.53578 5.01787C1.44649 5.24109 1.58042 5.4643 1.80364 5.50894Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4108 12.7859L10.5536 9.8395C11.0447 9.2145 11.4018 8.50021 11.625 7.74128C11.7143 7.51807 11.5804 7.29485 11.4018 7.25021C11.2232 7.20557 10.9554 7.29485 10.9107 7.47342C10.9107 7.51807 10.9107 7.51807 10.9107 7.56271C10.4197 9.527 8.6786 10.9556 6.62502 10.9556C4.8393 10.9556 3.23215 9.8395 2.56251 8.18771L3.36608 7.3395C3.41072 7.29485 3.36608 7.20557 3.32144 7.20557H1.08929C1.04464 7.20557 1 7.25021 1 7.29485V9.48236C1 9.57165 1.08929 9.61629 1.13393 9.527L1.84822 8.76807C2.74108 10.5538 4.5268 11.7145 6.53573 11.7592C7.78574 11.7592 9.03574 11.2681 9.97324 10.4199L12.8304 13.3663C12.9643 13.5449 13.2322 13.5449 13.3661 13.3663C13.5447 13.2324 13.5447 12.9645 13.4108 12.7859Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindBlk);
export default __webpack_public_path__ + "static/media/find-blk.06c92af6ce57e635418597820cd29433.svg";
export { ForwardRef as ReactComponent };